module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Search for keywords and lists...","submit":"Search"},"de":{"label":"Suche nach Listen und Schlüsselwörter...","submit":"Suchen"}}')
  delete Component.options._Ctor
}
